module.exports = __webpack_public_path__ + "static/media/33-web-or-mls-DSC06800.a6a3c207.jpg";